

const baseUrl = process.env.VUE_APP_API;
const authority = process.env.VUE_APP_AUTHORITY;
const logoutUrl = process.env.VUE_APP_LOGOUT_URL;

module.exports = {
	logoutUrl,
	baseUrl,
	authority
}

